// navigation selectors
export const GET_APPMAP = 'GET_APPMAP';


// navigation reducers
export const SET_APPMAP = 'SET_APPMAP';